import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch dynamic pricing API
   * @param query
   */
  fetchDynamicPrize: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/dynamic-pricing/pricing-type-wise-revenue`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch dynamic pricing API for export
   * @param query
   */
  fetchDynamicPrizeExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/dynamic-pricing/pricing-type-wise-revenue-export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch one station details API
   * @param query
   */
  fetchStationDetails: (stationId: string) => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/dynamic-pricing/station/${stationId}`,
      {},
    );
  },
  /**
   * Fetch one station details API
   * @param query
   */
  oldTimingChanges: (stationId: string) => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/dynamic-pricing/${stationId}`, {});
  },
  /**
   * Update the prizing api function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  updateDynamicPrizing: (data: any): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/facility/v1/dynamic-pricing/update-pricing`,
      data,
      false,
    );
  },
  /**
   * Update the timing api function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  updateDynamicTiming: (data: any): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/facility/v1/dynamic-pricing/update-timing`,
      data,
      false,
    );
  },
};
